<div class="admin-user-groups-container">
  <app-datatable
    data-testid="admin-user-groups-datatable"
    [rowData]="dataSource().data"
    [columns]="datatableColumns"
    [configurationInput]="datatableConfig"
    [customColumnDef]="[
      { name: 'name', isSortable: true, template: nameColumn },
      { name: 'currentConcurrentCampaigns', isSortable: true, template: currentCampaignsColumn },
      { name: 'effectiveMaxConcurrentCampaigns', isSortable: false, template: effectiveMaxCampaignsColumn },
      { name: 'currentCreatorChannels', isSortable: true, template: currentChannelsColumn },
      { name: 'effectiveMaxCreatorChannels', isSortable: false, template: effectiveMaxChannelsColumn },
      { name: 'currentSeats', isSortable: true, template: currentSeatsColumn },
      { name: 'effectiveMaxSeats', isSortable: false, template: effectiveMaxSeatsColumn },
      { name: 'endDateRead', isSortable: true, template: endReadColumn },
      { name: 'endDateWrite', isSortable: true, template: endWriteColumn },
      { name: 'tokenUsage', isSortable: false, template: tokenUsageColumn },
    ]"
    [total]="store.dataTotal$()"
    [loaderConfig]="skeletonLoaderConfig"
    [isInitialDataLoaded]="loadedTableData()"
    [loadingData]="store.dataLoading$()"
    (dataRefreshRequest)="datatableParams$.next($event)"
    (rowClick)="onRowClick($event)"
  />

  <ng-template #nameColumn let-row="row">
    <div class="flex items-center">
      <span class="font-bold">{{ row.name }}</span>
    </div>
  </ng-template>

  <ng-template #currentCampaignsColumn let-row="row">
    <div class="flex items-center">
      <span>{{ row.currentConcurrentCampaigns }}</span>
    </div>
  </ng-template>

  <ng-template #effectiveMaxCampaignsColumn let-row="row">
    <div class="flex items-center">
      <span>{{ row.effectiveMaxConcurrentCampaigns ?? '∞' }}</span>
    </div>
  </ng-template>

  <ng-template #currentChannelsColumn let-row="row">
    <div class="flex items-center">
      <span>{{ row.currentCreatorChannels }}</span>
    </div>
  </ng-template>

  <ng-template #effectiveMaxChannelsColumn let-row="row">
    <div class="flex items-center">
      <span>{{ row.effectiveMaxCreatorChannels ?? '∞' }}</span>
    </div>
  </ng-template>

  <ng-template #currentSeatsColumn let-row="row">
    <div class="flex items-center">
      <span>{{ row.currentSeats }}</span>
    </div>
  </ng-template>

  <ng-template #effectiveMaxSeatsColumn let-row="row">
    <div class="flex items-center">
      <span>{{ row.effectiveMaxSeats ?? '∞' }}</span>
    </div>
  </ng-template>

  <ng-template #endReadColumn let-row="row">
    <div class="flex items-center">
      <span>{{ row.endDateRead ? (row.endDateRead | date: 'dd.MM.yyyy') : '-' }}</span>
    </div>
  </ng-template>

  <ng-template #endWriteColumn let-row="row">
    <div class="flex items-center">
      <span>{{ row.endDateWrite ? (row.endDateWrite | date: 'dd.MM.yyyy') : '-' }}</span>
    </div>
  </ng-template>

  <ng-template #tokenUsageColumn let-row="row">
    <div class="flex items-center">
      @if (row.tokenUsage !== null && row.tokenUsage !== undefined) {
        <span
          [class.text-shikenso-error-base]="row.tokenUsage >= 1.0"
          [class.text-shikenso-warning-base]="row.tokenUsage >= 0.8 && row.tokenUsage < 1.0"
        >
          {{ row.tokenUsage * 100 | number: '1.0-1' }}%
        </span>
      } @else {
        <span>-</span>
      }
    </div>
  </ng-template>
</div>
